let bindToGlobal = (obj, key='var') => {
    if (typeof window[key] === 'undefined') {
        window[key] = {};
    }
    
    for (let i in obj) {
        window[key][i] = obj[i]
    }
}


window.http = {
	"host":"http://h5.baojinews.com",
	"path":"/static/things/",
};

bindToGlobal(http, '_const');
